module.exports = __webpack_public_path__ + "static/media/back.ca6aee54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/back.svg
// module id = 263
// module chunks = 0